import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { StyledBalanceLabel, StyledMaxButton, StyledWrapper } from './styled'
import Tooltip from '~/components/Tooltip'
import { toBigNumber, formatFormAmount } from '~/utils/numbers'
import { AddressZero } from '@ethersproject/constants'

export interface IBalanceLabel {
  inputToken: BaseTokenlonToken
  balance: string
  gasFeeEther: string
  showMax?: boolean
  onMaxClick?: () => void
}

export const BalanceLabel: React.FC<IBalanceLabel> = ({
  inputToken,
  balance,
  gasFeeEther,
  showMax,
  onMaxClick,
}) => {
  const { t } = useTranslation()
  const isSellETH = inputToken?.address === AddressZero
  const maxTradableETHBalance = useMemo(() => {
    let result = balance
    if (isSellETH) {
      const calcBalance = toBigNumber(balance).minus(gasFeeEther ?? 0)
      if (calcBalance.lt(0)) {
        result = '0'
      } else result = calcBalance.toFixed()
    }
    return result
  }, [balance, gasFeeEther])

  return (
    <StyledWrapper>
      <StyledBalanceLabel>
        {t('balance')}: {formatFormAmount(balance, 4)} {inputToken.symbol}
      </StyledBalanceLabel>
      {showMax ? (
        isSellETH ? (
          <Tooltip
            placement="right"
            title={t('spotswap_max_btn_tooltip')}
            tooltipTitle={t('spotswap_max_btn_tooltip_title')}
            tooltipTitleValue={`${formatFormAmount(maxTradableETHBalance)} ETH`}
            trigger="hover"
          >
            <StyledMaxButton onClick={onMaxClick}>MAX</StyledMaxButton>
          </Tooltip>
        ) : (
          <StyledMaxButton onClick={onMaxClick}>MAX</StyledMaxButton>
        )
      ) : null}
    </StyledWrapper>
  )
}
